const authBasePrefix = `/auth`;
export const auth = {
  login: () => `${authBasePrefix}/login`,
  twoFactor: () => `${authBasePrefix}/2factor`,
  logout: () => `${authBasePrefix}/logout`,
  recovery: () => `${authBasePrefix}/recovery`,
};

const accountsBasePrefix = '/accounts';
export const accounts = {
  account: () => accountsBasePrefix,
  transactions: (id: string) => `${accountsBasePrefix}/${id}/transactions`,
  allTransactions: (id: string) => `${accountsBasePrefix}/${id}/alltransactions`,
};

const cardsBasePrefix = '/cards';
export const cards = {
  cards: () => `${cardsBasePrefix}`,
  addCard: () => `${cardsBasePrefix}/new`,
  topUp: (cardId: string) => `${cardsBasePrefix}/${cardId}/topup`,
  downloadStatement: (cardId: string, token: string) => `${cardsBasePrefix}/${cardId}/statement/${token}`,
};

const messagesBasePrefix = '/messages';
export const messages = {
  getMessages: (type: string) => `${messagesBasePrefix}/${type}`,
  getNewMessagesInfo: () => `${messagesBasePrefix}/ping`,
  markAsRead: (messageId: string) => `${messagesBasePrefix}/${messageId}`,
  sendMessage: () => messagesBasePrefix,
};

const miscBasePrefix = '/metadata';
export const misc = {
  contacts: () => `${miscBasePrefix}/contacts`,
  dictionaries: () => `${miscBasePrefix}/dictionaries`,
  password: () => `/common/approve/password`,
};

const userBasePrefix = '/user';
export const user = {
  status: () => `${userBasePrefix}/me`,
};

const paymentsBasePrefix = '/payments';
export const payments = {
  checkLimit: () => `${paymentsBasePrefix}/checklimit`,
  requisites: () => `${paymentsBasePrefix}/requisites`,
  deleteRequisites: (id: string) => `${paymentsBasePrefix}/requisites/${id}`,
  external: () => `${paymentsBasePrefix}/external`,
  internal: () => `${paymentsBasePrefix}/internal`,
};
